import React, { useState, useEffect } from "react";

import Switch from "./Switch.js";
import Items from "./Items";
import Container from "@material-ui/core/Container";
import Loading from "../Loading";
import { IconButton } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { Add } from "@material-ui/icons/";
import url from "../../constants/URL.js";

const ShopManagement = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    const token = await JSON.parse(window.localStorage.getItem("persist:auth"))
      .token;
    fetch(`${url}/shop/${props.match.params.sellerID}/menu`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (response) => {
      const data = await response.json();
      setData(data);
      setLoading(false);
    });
  }

  const { sellerID } = props.match.params;

  if (loading) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return <div>No data</div>;
  }

  const open = data.open;
  const items = data.items;
  return (
    <div>
      <Container style={{ width: "90%",marginBottom:30 }}>
        <div style={{ textAlign: "center" }}>
          <span style={{ display: "inline-flex",alignItems:'center' }}>
            <h3>Shop Status:</h3>
            <div style={{ margin: "20px" }}>
              <b>Close</b>
              <Switch switch={open} sellerID={sellerID} shop={true} />
              <b> Open</b>
            </div>
          </span>
          <h3
            style={{
              backgroundColor: "antiquewhite",
              padding: "20px 0",
              borderRadius: "20px",
            }}
          >
            Inventory
          </h3>
          <div style={{ display: "flex", marginBottom: 10 }}>
            <NavLink
              to={"/add/item"}
              exact={true}
              style={{
                background: "cornflowerblue",
                borderRadius: 10,
                textDecoration: "none",
                marginBottom: 10,
                color: "white",
                paddingRight: 20,
              }}
            >
              <IconButton color="inherit">
                <Add />
              </IconButton>
              Add Item
            </NavLink>
          </div>
          <Items items={items} history={props.history}/>
        </div>
      </Container>
    </div>
  );
};

export default ShopManagement;
